import "./MarketsSummaryComponent.scss";

export const MarketSummary = "tfMarketSummary";

export function marketSummary() {
    return {
        templateUrl: "app/components/markets/MarketsSummaryComponent.html",
        controllerAs: "ctrl",
        controller: MarketsSummaryComponentController
    };
}

export class MarketsSummaryComponentController {
    public open = false;
    public display = null;
}
